import { render, staticRenderFns } from "./ExportPayments.vue?vue&type=template&id=bbcf0366&scoped=true"
import script from "./ExportPayments.vue?vue&type=script&lang=js"
export * from "./ExportPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcf0366",
  null
  
)

export default component.exports